import React, { useState } from "react";
import { SketchPicker } from "react-color";

import "./DataLabel.css"; // Ensure you have a corresponding CSS file for styling

const DataLabels = ({ setChartConfig, chartConfig }) => {
  const [showTextColorPicker, setShowTextColorPicker] = useState(false);
  const [showForeColorPicker, setShowForeColorPicker] = useState(false);
  const [showBorderColorPicker, setShowBorderColorPicker] = useState(false);
  const [showShadowColorPicker, setShowShadowColorPicker] = useState(false);

  const handleDataLabels = (key, value) => {
    setChartConfig((prevConfig) => ({
      ...prevConfig,
      dataLabels: { ...prevConfig.dataLabels, [key]: value }
    }));
  };

  const handleBackGround = (key, value) => {
    setChartConfig((prevConfig) => ({
      ...prevConfig,
      dataLabels: { ...prevConfig.dataLabels, background: { [key]: value } }
    }));
  };

  const handleDropShadow = (key, value) => {
    setChartConfig((prevConfig) => ({
      ...prevConfig,
      dataLabels: {
        ...prevConfig.dataLabels,
        dropShadow: { [key]: value }
      }
    }));
  };

  return (
    <div className="data-labels-settings-container">
      <h3>Data Labels Settings</h3>

      {/* Show Data Labels */}
      <div className="data-labels-settings-section">
        <label className="data-labels-settings-label">Show</label>
        <input
          type="checkbox"
          checked={chartConfig?.dataLabels?.enabled}
          onChange={(e) => handleDataLabels("enabled", e.target.checked)}
        />
      </div>

      {/* Labels Left Offset */}
      <div className="data-labels-settings-section">
        <label className="data-labels-settings-label">Labels Left Offset</label>
        <input
          type="number"
          value={chartConfig?.dataLabels?.offsetX || 7}
          onChange={(e) => handleDataLabels("offsetX", Number(e.target.value))}
        />
      </div>

      {/* Labels Top Offset */}
      <div className="data-labels-settings-section">
        <label className="data-labels-settings-label">Labels Top Offset</label>
        <input
          type="number"
          value={chartConfig?.dataLabels?.offsetY || 0}
          onChange={(e) => handleDataLabels("offsetY", Number(e.target.value))}
        />
      </div>

      {/* Font Size */}
      <div className="data-labels-settings-section">
        <label className="data-labels-settings-label">Font Size</label>
        <input
          type="number"
          value={chartConfig?.dataLabels?.style?.fontSize || 12}
          onChange={(e) =>
            handleDataLabels("style", {
              ...chartConfig?.dataLabels?.style,
              fontSize: Number(e.target.value)
            })
          }
        />
      </div>

      {/* Font Weight */}
      <div className="data-labels-settings-section">
        <label className="data-labels-settings-label">Font Weight</label>
        <select
          value={chartConfig?.dataLabels?.style?.fontWeight || "normal"}
          onChange={(e) =>
            handleDataLabels("style", {
              ...chartConfig?.dataLabels?.style,
              fontWeight: e.target.value
            })
          }
          className="data-labels-settings-dropdown"
        >
          <option value="normal">Normal</option>
          <option value="bold">Bold</option>
        </select>
      </div>

      {/* Colors */}
      <div className="color-picker-wrapper">
        <label className="data-labels-settings-label">Colors</label>
        <button className="color-picker-button" onClick={() => setShowTextColorPicker(!showTextColorPicker)}>
          <div
            className="color-swatch"
            style={{
              backgroundColor: chartConfig?.dataLabels?.style?.colors?.[0] || "#000000"
            }}
          />
        </button>
        {showTextColorPicker && (
          <div className="picker-popover">
            <div className="picker-cover" onClick={() => setShowTextColorPicker(false)} />
            <SketchPicker
              color={chartConfig?.dataLabels?.style?.colors?.[0] || "#000000"}
              onChangeComplete={(color) =>
                handleDataLabels("style", {
                  ...chartConfig?.dataLabels?.style,
                  colors: [color.hex]
                })
              }
            />
          </div>
        )}
      </div>

      {/* Background */}
      <div className="data-labels-settings-section">
        <label className="data-labels-settings-label">Background</label>
        <div className="background-settings">
          {/* Enable Background */}
          <div className="background-setting">
            <label>Enable</label>
            <input
              type="checkbox"
              checked={chartConfig?.dataLabels?.background?.enabled || false}
              onChange={(e) => handleBackGround("enabled", e.target.checked)}
            />
          </div>

          {/* ForeColor */}
          <div className="color-picker-wrapper">
            <label>ForeColor</label>
            <button className="color-picker-button" onClick={() => setShowForeColorPicker(!showForeColorPicker)}>
              <div
                className="color-swatch"
                style={{
                  backgroundColor: chartConfig?.dataLabels?.background?.foreColor || "#ffffff"
                }}
              />
            </button>
            {showForeColorPicker && (
              <div className="picker-popover">
                <div className="picker-cover" onClick={() => setShowForeColorPicker(false)} />
                <SketchPicker
                  color={chartConfig?.dataLabels?.background?.foreColor || "#ffffff"}
                  onChangeComplete={(color) => handleBackGround("foreColor", color.hex)}
                />
              </div>
            )}
          </div>

          {/* Border Color */}
          <div className="color-picker-wrapper">
            <label>Border Color</label>
            <button className="color-picker-button" onClick={() => setShowBorderColorPicker(!showBorderColorPicker)}>
              <div
                className="color-swatch"
                style={{
                  backgroundColor: chartConfig?.dataLabels?.background?.borderColor || "#000000"
                }}
              />
            </button>
            {showBorderColorPicker && (
              <div className="picker-popover">
                <div className="picker-cover" onClick={() => setShowBorderColorPicker(false)} />
                <SketchPicker
                  color={chartConfig?.dataLabels?.background?.borderColor || "#000000"}
                  onChangeComplete={(color) => handleBackGround("borderColor", color.hex)}
                />
              </div>
            )}
          </div>

          {/* Border Radius */}
          <div className="background-setting">
            <label>Border Radius</label>
            <input
              type="number"
              value={chartConfig?.dataLabels?.background?.borderRadius || 0}
              onChange={(e) => handleBackGround("borderRadius", Number(e.target.value))}
            />
          </div>

          {/* Border Width */}
          <div className="background-setting">
            <label>Border Width</label>
            <input
              type="number"
              value={chartConfig?.dataLabels?.background?.borderWidth || 0}
              onChange={(e) => handleBackGround("borderWidth", Number(e.target.value))}
            />
          </div>

          {/* Opacity */}
          <div className="background-setting">
            <label>Opacity</label>
            <input
              type="number"
              step="0.1"
              min="0"
              max="1"
              value={chartConfig?.dataLabels?.background?.opacity || 1}
              onChange={(e) => handleBackGround("opacity", Number(e.target.value))}
            />
          </div>
        </div>
      </div>

      {/* Padding */}
      <div className="data-labels-settings-section">
        <label className="data-labels-settings-label">Padding</label>
        <input
          type="number"
          value={chartConfig?.dataLabels?.background?.padding || 0}
          onChange={(e) => handleBackGround("padding", Number(e.target.value))}
        />
      </div>

      {/* Text DropShadow */}
      <div className="data-labels-settings-section">
        <label className="data-labels-settings-label">Text DropShadow</label>
        <div className="text-shadow-settings">
          {/* Enable Shadow */}
          <div className="text-shadow-setting">
            <label>Enable</label>
            <input
              type="checkbox"
              checked={chartConfig?.dataLabels?.dropShadow?.enabled || false}
              onChange={(e) => handleDropShadow("enabled", e.target.checked)}
            />
          </div>

          {/* Blur */}
          <div className="text-shadow-setting">
            <label>Blur</label>
            <input
              type="number"
              value={chartConfig?.dataLabels?.dropShadow?.blur || 0}
              onChange={(e) => handleDropShadow("blur", Number(e.target.value))}
            />
          </div>

          {/* Offset X */}
          <div className="text-shadow-setting">
            <label>Offset X</label>
            <input
              type="number"
              value={chartConfig?.dataLabels?.dropShadow?.offsetX || 0}
              onChange={(e) => handleDropShadow("offsetX", Number(e.target.value))}
            />
          </div>

          {/* Offset Y */}
          <div className="text-shadow-setting">
            <label>Offset Y</label>
            <input
              type="number"
              value={chartConfig?.dataLabels?.dropShadow?.offsetY || 0}
              onChange={(e) => handleDropShadow("offsetY", Number(e.target.value))}
            />
          </div>

          {/* Shadow Color */}
          <div className="color-picker-wrapper">
            <label>Shadow Color</label>
            <button className="color-picker-button" onClick={() => setShowShadowColorPicker(!showShadowColorPicker)}>
              <div
                className="color-swatch"
                style={{
                  backgroundColor: chartConfig?.dataLabels?.dropShadow?.color || "#000000"
                }}
              />
            </button>
            {showShadowColorPicker && (
              <div className="picker-popover">
                <div className="picker-cover" onClick={() => setShowShadowColorPicker(false)} />
                <SketchPicker
                  color={chartConfig?.dataLabels?.dropShadow?.color || "#000000"}
                  onChangeComplete={(color) => handleDropShadow("color", color.hex)}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataLabels;
